<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="Dedication-ded" id="ded"><span aria-label="5" id="pg_5" role="doc-pagebreak"><i>This one is for my parents</i></span></p>
<p class="Dedication-ded"><i>And for all my queer fam’</i></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f69d20be